import { DeleteOutlined } from '@ant-design/icons';

export const DeleteIcon = ({ ...props }) => (
  <DeleteOutlined style={{ color: 'red', cursor: 'pointer' }} {...props} />
);
